<template>
  <div class="filter-bar">
    <div class="date-row">
      <div class="date-cell" @click="showStartPicker = true">
        <div class="lb">{{ $t('query.startTime') }}</div>
        <div class="vl" :class="{ ph: !startTime }">{{ startTime || $t('query.startTimePlaceholder') }}</div>
      </div>
      <div class="date-arrow">→</div>
      <div class="date-cell" @click="showEndPicker = true">
        <div class="lb">{{ $t('query.endTime') }}</div>
        <div class="vl" :class="{ ph: !endTime }">{{ endTime || $t('query.startTimePlaceholder') }}</div>
      </div>
    </div>
    <van-button block size="small" class="brand-btn search-btn" @click="onSearch">
      {{ $t('common.search') }}
    </van-button>

    <van-popup v-model:show="showStartPicker" position="bottom" round>
      <van-datetime-picker type="date" :title="$t('query.pickerTitle')" @confirm="onConfirmStart" @cancel="showStartPicker = false" />
    </van-popup>
    <van-popup v-model:show="showEndPicker" position="bottom" round>
      <van-datetime-picker type="date" :title="$t('query.pickerTitle')" @confirm="onConfirmEnd" @cancel="showEndPicker = false" />
    </van-popup>
  </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue';
import { formatDate } from '@/utils';
const emit = defineEmits(['search']);
const startTime = ref('');
const endTime = ref('');
const showStartPicker = ref(false);
const showEndPicker = ref(false);

const onConfirmStart = (v) => {
  startTime.value = formatDate(v);
  showStartPicker.value = false;
};
const onConfirmEnd = (v) => {
  endTime.value = formatDate(v);
  showEndPicker.value = false;
};
const onSearch = () => {
  emit('search', { startTime: startTime.value, endTime: endTime.value });
};
</script>

<style lang="scss" scoped>
.filter-bar {
  padding: 20px 16px 16px;
  background: #fff;
  margin-bottom: 20px;
}
.date-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  .date-cell {
    flex: 1;
    background: #f5f7fa;
    border-radius: 12px;
    padding: 14px 18px;
    .lb {
      font-size: 20px;
      color: var(--text-muted);
      margin-bottom: 4px;
    }
    .vl {
      font-size: 26px;
      font-weight: 500;
      color: var(--text-primary);
      &.ph {
        color: #cbd5e1;
        font-weight: 400;
        font-size: 22px;
      }
    }
  }
  .date-arrow {
    color: var(--text-muted);
    font-size: 26px;
  }
}
.search-btn {
  height: 70px !important;
  font-size: 26px !important;
}
</style>
